import * as React from 'react';
import EmptyProgressPng from './empty-progress-card.png';
import { Button } from '../../../commonv3/components/atoms/buttons/Button';
import './emptyProgressCard.module.scss';
import { GlobalStatesV3 } from '../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../routes';

export const EmptyProgressCard = () => (
    <div styleName="empty-progress-card">
        <img src={EmptyProgressPng} styleName="icon" />
        <div styleName="body">
            <div>
                <div styleName="header">レッスンを始めよう</div>
                <div styleName="text">まだ学習中のレッスンはありません。コース一覧からレッスンをはじめましょう。</div>
            </div>
            <Button
                styleName="button"
                type="normal"
                size="s"
                onClick={() => GlobalStatesV3.routing.push(V3Routes.courses())}
            >
                コース一覧へ
            </Button>
        </div>
    </div>
);
